import { DocumentFolderTreeNode } from 'compliance-api';

export const findNodeById = (
  nodes: DocumentFolderTreeNode[],
  targetId: number,
): DocumentFolderTreeNode | null => {
  for (const node of nodes) {
    if (node.id === targetId) return node;

    if (node.children && node.children.length > 0) {
      const result = findNodeById(node.children, targetId);
      if (result) return result;
    }
  }
  return null;
};

export const findNodePath = (
  nodes: DocumentFolderTreeNode[],
  targetId: number,
  path: DocumentFolderTreeNode[] = [],
): DocumentFolderTreeNode[] | null => {
  for (const node of nodes) {
    const currentPath = [...path, node];

    if (node.id === targetId) return currentPath;

    if (node.children && node.children.length > 0) {
      const result = findNodePath(node.children, targetId, currentPath);

      if (result) return result;
    }
  }
  return null;
};
